<template>
  <div>
    <top-nav></top-nav>
    <div class="center_container">
      <div class="crumb">首页 / 俱乐部</div>

      <div class="hd_top">
        <div class="top_left">
          <img alt="" src="../../assets/image/game/hd.png">
        </div>
        <div class="top_right">
          <div v-for="item in hdList" :key="item.id" class="hd_item">
            <div class="hd_title">{{ item.title }}</div>
            <div style="margin: 22px 0 12px">开始时间：{{ item.startTime }}</div>
            <div>结束时间：{{ item.endTime }}</div>
          </div>
        </div>
      </div>

      <el-tabs v-model="activeName">
        <el-tab-pane label="热门俱乐部" name="1"></el-tab-pane>
        <el-tab-pane label="最新俱乐部" name="2"></el-tab-pane>
      </el-tabs>

      <div class="club_list">
        <div v-for="item in clubList" :key="item.id" class="hover_style club_item">
          <img :src="require(`../../assets/image/club/c${item.id}.png`)" alt="" class="i_img">
          <div class="i_info">
            <div class="text_overflow i_name">{{ item.name }}</div>
            <div class="display_flex i_bot">
              <div>{{ item.type }}</div>
              <div class="display_flex">
                <img alt="" src="../../assets/image/index/icon_local.png" style="margin-right: 8px">
                {{ item.city }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="display_flex" style="justify-content: center">
        <el-pagination
            background
            layout="prev, pager, next"
            :total="100">
        </el-pagination>
      </div>
    </div>
    <bot-nav></bot-nav>
  </div>
</template>

<script>
export default {
  name: "club",
  data () {
    return {
      // 活动列表
      hdList: [
        { id: 1, title: '玩转世界杯，一起看球一起嗨', startTime: '2023-07-31', endTime: '2023-08-31' },
        { id: 2, title: '玩转世界杯，一起看球一起嗨', startTime: '2023-07-31', endTime: '2023-08-31' },
        { id: 3, title: '玩转世界杯，一起看球一起嗨', startTime: '2023-07-31', endTime: '2023-08-31' }
      ],

      activeName: '1',

      // 俱乐部列表
      clubList: [
        { id: 1, name: 'SC足球俱乐部', type: '足球', city: '沈阳' },
        { id: 2, name: '沈阳MOUNTAIN俱乐部', type: '高尔夫', city: '沈阳' },
        { id: 3, name: '沈阳GCU排球俱乐部', type: '电子竞技', city: '沈阳' },
        { id: 4, name: '大连CUP足球俱乐部', type: '电子竞技', city: '沈阳' },
        { id: 5, name: '沈阳游泳俱乐部', type: '电子竞技', city: '沈阳' },
        { id: 6, name: '盘锦乒乓球俱乐部', type: '电子竞技', city: '沈阳' },
        { id: 7, name: '沈阳芳江羽毛球俱乐部', type: '电子竞技', city: '沈阳' },
        { id: 8, name: '沈阳B41篮球俱乐部', type: '电子竞技', city: '沈阳' },
        { id: 9, name: '鞍山宝达足球俱乐部', type: '电子竞技', city: '沈阳' },
        { id: 10, name: '抚顺伟达篮球俱乐部', type: '电子竞技', city: '沈阳' },
        { id: 11, name: '沈阳长跑俱乐部', type: '电子竞技', city: '沈阳' },
        { id: 12, name: '大连GYM健身俱乐部', type: '电子竞技', city: '沈阳' },
      ],
    }
  }
}
</script>

<style lang="less" scoped>
.center_container {
  padding-bottom: 60px;

  .hd_top {
    display: flex;
    margin-bottom: 72px;

    .top_left {
      width: 55%;

      img {
        width: 100%;
        height: 100%;
        //object-fit: cover;
      }
    }

    .top_right {
      width: 45%;

      .hd_item {
        padding: 39px 32px;
        font-size: 16px;
        border-bottom: 1px solid #DCDCDC;
        cursor: pointer;

        &:hover {
          background: #0058A6;
          color: #FFFFFF;
        }

        .hd_title {
          font-weight: 700;
          font-size: 32px;
        }
      }
    }
  }

  .club_list {
    display: flex;
    flex-wrap: wrap;
    margin: 40px 0;

    .club_item {
      width: calc((100% - 72px) / 4);
      margin-right: 16px;
      margin-bottom: 16px;
      border: 1px solid #DCDCDC;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .i_img {
        width: 100%;
      }

      .i_info {
        padding: 16px 24px 21px;
        font-size: 16px;

        .i_name {
          font-weight: 500;
          font-size: 24px;
          margin-bottom: 16px;
        }
      }
    }
  }
}
</style>
